// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonDuplicate_wrap__EmwU-","icon":"ButtonDuplicate_icon__+KAhO"};